/* eslint-disable no-undef */
export default class ShopifyUser {
  constructor() {
    this.domain = __SHOPIFY_DOMAIN__;
    this.token = __SHOPIFY_TOKEN__;
    this.apiVersion = __SHOPIFY_API_VERSION__;

    this.modalId = "user-modal";
    this.modalContentId = "user-modal-content";
    this.toggleId = "shopify-user-toggle";

    this.endpoint = `https://${this.domain}/api/${this.apiVersion}/graphql.json`;

    this.init();
  }

  init() {
    const toggle = document.getElementById(this.toggleId);
    if (!toggle) return;

    toggle.addEventListener("click", () => this.openModal());

    const modal = document.getElementById(this.modalId);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) modal.style.display = "none";
    });
  }

  async openModal() {
    const modal = document.getElementById(this.modalId);
    const content = document.getElementById(this.modalContentId);

    modal.style.display = "block";
    content.innerHTML = `<p>Caricamento...</p>`;

    const customer = await this.getCustomer();

    if (customer) {
      content.innerHTML = `
        <h2>Ciao ${customer.firstName}</h2>
        <p>Sei loggato</p>
      `;
    } else {
      content.innerHTML = `
        <h2>Area utente</h2>
        <a href="https://${this.domain}/account/register" class="btn">
          Registrati
        </a>
      `;
    }
  }

  async getCustomer() {
    const customerToken = localStorage.getItem("customerToken");
    if (!customerToken) return null;

    const query = `
      query ($token: String!) {
        customer(customerAccessToken: $token) {
          firstName
        }
      }
    `;

    try {
      const res = await fetch(this.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.token,
        },
        body: JSON.stringify({
          query,
          variables: { token: customerToken },
        }),
      });

      const { data } = await res.json();
      return data?.customer ?? null;
    } catch {
      return null;
    }
  }
}
